var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.069,
    height: 11.918,
    viewBox: "0 0 19.069 11.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye",
    "data-name": "Icon awesome-eye",
    d: "M18.954,10.006A10.706,10.706,0,0,0,9.535,4.5,10.707,10.707,0,0,0,.115,10.006a.948.948,0,0,0,0,.906,10.706,10.706,0,0,0,9.419,5.506,10.707,10.707,0,0,0,9.419-5.506A.948.948,0,0,0,18.954,10.006ZM9.535,14.929a4.626,4.626,0,0,1-4.767-4.469A4.626,4.626,0,0,1,9.535,5.99,4.626,4.626,0,0,1,14.3,10.459,4.623,4.623,0,0,1,9.535,14.929Zm0-7.449A3.351,3.351,0,0,0,8.7,7.6a1.417,1.417,0,0,1-.156,1.93,1.664,1.664,0,0,1-2.059.146,2.884,2.884,0,0,0,1.294,3.247,3.343,3.343,0,0,0,3.7-.109,2.865,2.865,0,0,0,1.072-3.317A3.163,3.163,0,0,0,9.535,7.48Z",
    transform: "translate(0 -4.5)",
    fill: "#dedede"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.21f24f826a07a3c293fe21754be64af5.svg";
export { ForwardRef as ReactComponent };